const initialState = {
  loading: false,   
    data: null,
    error: null,
};

const partnerPayoutSummaryLanDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PARTNER_PAYOUT_LANDATA_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case "GET_PARTNER_PAYOUT_LANDATA_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


export default partnerPayoutSummaryLanDataReducer;